<script>
    import * as BusinessDAL from "../dal/business-dal";
    import LoadingAnim from "./LoadingAnim.svelte";
    import { push } from "svelte-spa-router";

    export let card;

</script>

{#if !card.details}
    <div class="cardLoading card cardLoading">
        <LoadingAnim color={'var(--blue1)'} />
    </div>
{:else}
    <div class="card">
        <div class="stamps">
            {#each Array(card.details.collectibleCount) as _, i}
                <div class="stamp">
                    {#if i < card.numberOfStamps}
                        <div
                            class="icon"
                            style={`transform: rotate(${Math.random() * 25}deg) translate(${Math.random() * 5 - 2.5}px, ${Math.random() * 5 - 2.5}px)`}
                        >
                            <img src="images/logo_white.svg" alt="stamp icon" />
                        </div>
                    {:else}
                        <div class="number">{i + 1}</div>
                    {/if}
                </div>
            {/each}

            {#if card.numberOfStamps >= card.details.collectibleCount}
                <div class="cardReady">
                    <div class="circleBg">
                        <span>ניתן למימוש בהזמנה הבאה!</span>
                    </div>
                </div>
            {/if}
        </div>

        <div
            class="details"
            style={`background-image: url(${BusinessDAL.getCoverImgUrl(card.businessId)})`}
            on:click={() => {
                push('/b/' + card.businessId);
            }}
        >
            <!-- <div class="gloss" /> -->
            <div class="businessTitle">
                {card.details.businessTitle}
                <div class="ruleTitle">{card.details.title}</div>
            </div>
        </div>
        <!-- <div
            class="paperTexture"
            style={`background-position-x: ${Math.random() * 400}px;
            background-position-y: ${Math.random() * 400}px;`}
        /> -->
    </div>
{/if}

<!-- markup (zero or more items) goes here -->
<style>
    /* .paperTexture {
        width: 100%;
        height: 100%;
        position: absolute;
        background-image: url("../images/paper-texture.jpg");
        background-size: cover;
        mix-blend-mode: darken;
        opacity: 0.7;
    } */
    /* .gloss {
        position: absolute;
        width: 100%;
        height: 100%;
        background: linear-gradient(
            38deg,
            rgb(255 255 255 / 23%) 3%,
            rgb(91 119 135 / 17%) 10%,
            rgb(230 230 230 / 63%) 25%,
            rgb(0 0 0 / 34%) 61%,
            rgb(218 229 235 / 54%) 84%
        );
        z-index: -1;
        mix-blend-mode: hard-light;
    } */
    .ruleTitle {
        font-size: 14px;
        margin-top: 10px;
    }
    .cardLoading {
        align-items: center;
        justify-content: center;
        box-sizing: border-box;
        padding: 20px;
    }
    .cardReady {
        color: var(--green1);
        position: absolute;
        right: 5px;
        bottom: 5px;
        border-radius: 100px;
        font-family: "Rubik", sans-serif;
        left: 0;
        right: 0;
        top: 0;
        bottom: 0;
        display: flex;
        align-items: center;
        justify-content: center;
        padding: 20px;
    }

    .circleBg {
        width: 180px;
        height: 180px;
        background: #35e541db;
        aspect-ratio: 1;
        max-width: 100%;
        border-radius: 100%;
        display: flex;
        align-items: center;
        justify-content: center;
        color: white;
        font-size: 2.5rem;
        text-align: center;
        font-style: italic;
        font-weight: lighter;
        direction: rtl;
        transform: rotate(4deg);
    }
    .businessTitle {
        background: #000000b0;
        padding: 10px;
    }

    .card {
        display: flex;
        background: white;
        border-radius: 12px 5px 5px 12px;
        box-shadow: 0 10px 10px -17px;
        position: relative;
        border-radius: 6px;
        overflow: hidden;
    }

    .stamps {
        width: 100%;
        display: flex;
        flex-wrap: wrap;
        gap: 10px;
        padding: 10px;
        box-sizing: border-box;
        position: relative;
    }
    .stamp {
        width: 80px;
        height: 80px;
        display: inline-flex;
        align-items: center;
        justify-content: center;
        background: var(--blue1);
        color: white;
        font-size: 18px;
        font-weight: 700;
        background: white;
        color: var(--blue1);
        border: 4px dashed;
        border-radius: 4px;
        flex-grow: 1;
    }

    .stamp > .icon {
        background: var(--blue1);
        border-radius: 1000px;
        border: 3px solid;
    }

    .details {
        min-width: 200px;
        color: white;
        font-size: 2rem;
        direction: rtl;
        box-sizing: border-box;
        display: flex;
        flex-direction: column;
        justify-content: space-between;
        font-weight: 600;
        background-size: 165%;
        background-position: 80% 50%;
        cursor: pointer;
        filter: sepia(0.5) saturate(1.7);
        opacity: 0.9;
    }

    .icon > img {
        width: 60px;
        height: 60px;
    }

    @media (max-width: 657px) {
        .card {
            flex-direction: column;
        }
    }

</style>
